import React, {useRef, useState, useEffect, useCallback} from "react";
import styled from "@emotion/styled";
import {useTheme} from "@emotion/react";
import {useMobileDetect} from "../../../utils/Hooks";
import {getImageUrl} from "../../../context/ApplicationContextProvider";

/*
    props
    content: DOM            subject의 description으로 저장된 dom
 */
const SubjectDescription = (props) => {
    const {is_mobile} = useMobileDetect();

    // state
    const [is_spread_subject_description, setIsSpreadSubjectDescription] = useState(false);
    const [description_height, setDescriptionHeight] = useState("auto");
    const [need_subject_description_summary, setNeedSubjectDescriptionSummary] = useState(false);

    // DOM ref
    const subject_description_ref = useRef();

    // css style
    const {view} = useComponentStyle(is_mobile, is_spread_subject_description);

    const new_exp_match = /(\b(http?|https):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;

    // 전달된 props.content(description)의 높이(height) 반환
    const getSubjectContentHeight = useCallback((content) => {
        let height = 0;
        const temp_div = document.createElement("div");
        temp_div.innerHTML = content;

        const hidden_div = document.getElementsByClassName("hidden-div")[0];
        hidden_div.appendChild(temp_div);

        height = hidden_div.clientHeight;

        // 높이 구한 뒤 자식요소(temp_div) 제거
        while (hidden_div.hasChildNodes()) {
            hidden_div.removeChild(hidden_div.firstChild);
        }

        return {height};
    }, []);

    // 전달된 content(description)의 높이가 65px 이상이면 63px로 수축, 65px 이하이면 전체 보여주기
    useEffect(() => {
        if (is_mobile) {
            if (props.content) {
                const {height} = getSubjectContentHeight(props.content);

                if (height >= 65) {
                    setDescriptionHeight("63px");
                    setNeedSubjectDescriptionSummary(true);
                    setIsSpreadSubjectDescription(false);
                } else {
                    setDescriptionHeight("auto");
                    setNeedSubjectDescriptionSummary(false);
                    setIsSpreadSubjectDescription(true);
                }
            }
        }
    }, [props.content, is_mobile, getSubjectContentHeight]);

    const subjectDescriptionSpread = () => {
        if (description_height === "63px") {
            setDescriptionHeight("auto");
        } else {
            setDescriptionHeight("63px");
        }

        setIsSpreadSubjectDescription(!is_spread_subject_description);
    };

    return (
        <>
            <view.SubjectDescriptionWrap
                style={{
                    overflow: "hidden",
                    height: description_height,
                }}
                ref={subject_description_ref}
                dangerouslySetInnerHTML={{
                    __html: props.content?.replace(
                        new_exp_match,
                        '<a target="_blank" rel="noreferrer" href="$1" style="color: #2f7abe">$1</a>'
                    ),
                }}
            />
            {need_subject_description_summary && (
                <view.MobileSubjectDescriptionSpreadButton>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                        onClick={() => {
                            subjectDescriptionSpread();
                        }}>
                        <div className="mobile-arrow-icon" />
                        <span>{is_spread_subject_description ? "접기" : "펼치기"}</span>
                    </div>
                </view.MobileSubjectDescriptionSpreadButton>
            )}
            <div className={"hidden-div"} />
        </>
    );
};

export default SubjectDescription;

export const useComponentStyle = (is_mobile, is_spread_subject_description) => {
    const theme = useTheme();
    return {
        view: {
            SubjectDescriptionWrap: styled.div({
                width: is_mobile ? "calc(100% - 2em)" : "100%",
                margin: is_mobile && "0 1em",
                color: theme.colors.dg1,
                transition: "all .2s",
                "@media (max-width: 320px)": {
                    width: "100%",
                    margin: "0",
                },
            }),
            MobileSubjectDescriptionSpreadButton: styled.div({
                margin: "1em",
                width: "calc(100% - 2em)",
                display: "flex",
                justifyContent: "center",
                color: theme.colors.dg2,
                fontSize: theme.font_size.f17,
                "@media (max-width: 320px)": {
                    fontSize: theme.font_size.f15,
                },
                "& .mobile-arrow-icon": {
                    width: ".8em",
                    height: ".8em",
                    marginRight: ".5em",
                    background: `url(${
                        is_spread_subject_description
                            ? getImageUrl("image/common/ic_arrow_up_grey.png")
                            : getImageUrl("image/common/ic_arrow_down_grey.png")
                    }) center center/contain no-repeat`,
                },
            }),
        },
    };
};
